import { getApiBaseUrl } from "../apiBaseUrlFinder";

export const searchService = {
  // Search for managers
  searchManagers: async (query, lastKey = null) => {
    const baseUrl = `${getApiBaseUrl()}/search`;
    let apiUrl = `${baseUrl}?search_type=managers&manager_full_name=${encodeURIComponent(
      query
    )}`;

    if (lastKey) {
      apiUrl += `&last_key=${encodeURIComponent(lastKey)}`;
    }

    const response = await fetch(apiUrl);
    const data = await response.json();

    if (data?.managers && Array.isArray(data.managers)) {
      return {
        managers: data.managers.map((item) => ({
          name: item.manager_full_name,
          id: item.manager_id,
          location: item.location || "Unknown",
          position: item.position || "Unknown",
          company_name: item.company_name || "N/A",
          company_logo_url: item.company_logo_url || null,
        })),
        lastKey: data.last_key ?? null,
      };
    }

    return { managers: [], lastKey: null };
  },

  // Search for companies (local search)
  searchCompanies: (
    query,
    companies,
    append = false,
    remainingCompanies = []
  ) => {
    const normalizedQuery = query.trim().toLowerCase().replace(/\s+/g, " ");

    if (!append) {
      const filteredCompanies = companies.filter((company) =>
        company.company_name.toLowerCase().includes(normalizedQuery)
      );

      return {
        companies: filteredCompanies.slice(0, 6).map((item) => ({
          name: item.company_name,
          id: item.company_id,
          location: item.location || "Unknown",
          industry: item.industry || "Unknown",
          company_logo_url: item.company_logo_url,
        })),
        remainingCompanies: filteredCompanies.slice(6),
      };
    } else {
      const nextBatch = remainingCompanies.slice(0, 6);
      return {
        companies: nextBatch.map((item) => ({
          name: item.company_name,
          id: item.company_id,
          location: item.location || "Unknown",
          industry: item.industry || "Unknown",
          company_logo_url: item.company_logo_url,
        })),
        remainingCompanies: remainingCompanies.slice(6),
      };
    }
  },
};
